import React from 'react'

import Layout from '../components/Layout'
import SEO from '../components/SEO'
import PageHeader from '../components/PageHeader'
import { PageContent } from '../styles/author.styles'

export default function AboutPage() {
  return (
    <Layout>
      <SEO title="Terms of Use" pathname={`/terms-of-use/`} />
      <PageHeader
        title={`Terms of Use`}
        desc={`There is some great content here, so use it wisely!`}
      />
      <PageContent>
        <h1>Terms of Use</h1>
        <p>BEHAVE</p>
      </PageContent>
    </Layout>
  )
}
